module.exports = __webpack_public_path__ + "static/media/CoachesAcademy.00b7d475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CoachesAcademy.png
// module id = 7005
// module chunks = 2